/**
 * Dynamically load images from a folder using require.context
 * Supports .jpg, .jpeg, .png, .webp, .gif
 * Returns array of { url, title }
 */
export const loadImagesFromFolder = (folderPath) => {
    try {
        const context = require.context('../assets', true, /\.(jpeg|jpg|png|gif|webp)$/i);

        // first try: flexible regex matching folder name (spaces/hyphens)
        const keys = context.keys().filter((key) => {
            const normalizedKey = key.replace(/\\/g, '/').toLowerCase();
            const pathLower = String(folderPath).toLowerCase();
            const escapedPath = pathLower.replace(/[\s-]/g, '[\\s\\-]');
            const folderRegex = new RegExp(`/(${escapedPath})/`, 'i');
            return folderRegex.test(normalizedKey);
        });

        // fallback: token matching (all tokens must appear anywhere in path)
        let keysFound = keys;
        if (!keysFound || keysFound.length === 0) {
            const tokens = String(folderPath)
                .toLowerCase()
                .split(/[^a-z0-9]+/)
                .filter(Boolean);

            if (tokens.length > 0) {
                const allKeys = context.keys();
                keysFound = allKeys.filter((k) => {
                    const nk = k.replace(/\\/g, '/').toLowerCase();
                    return tokens.every((t) => nk.includes(t));
                });
            }
        }

        const finalKeys = (keysFound && keysFound.length > 0) ? keysFound : [];

        return finalKeys.map((key) => ({
            url: context(key),
            title: key
                .split('/')
                .pop()
                .split('.')
                .slice(0, -1)
                .join('.')
                .replace(/[-_]/g, ' '),
        }));
    } catch (error) {
        console.error(`Error loading images from ${folderPath}:`, error);
        return [];
    }
};

export const normalizeFolderPath = (name) => {
    return String(name).toLowerCase().replace(/\s+/g, '-');
};

export const loadProjectImages = () => {
    return {
        'The Imperial Villa': loadImagesFromFolder('imperial-villa'),
        'Minimalist Elegance': loadImagesFromFolder('minimalist-elegance'),
        'Lounge Wall Paneling': loadImagesFromFolder('lounge-wall-paneling'),
        Construction: loadImagesFromFolder('construction'),
    };
};
